import { render, staticRenderFns } from "./WeightLenghtChart.vue?vue&type=template&id=541e1e10&"
import script from "./WeightLenghtChart.vue?vue&type=script&lang=ts&"
export * from "./WeightLenghtChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports